import {Component, HostListener, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CustomizationService} from '../../customization.service';
import {MatDialogRef} from '../../../side-dialog';
import {first} from 'rxjs/operators';

@Component({
    selector: 'lib-customization-icon',
    templateUrl: './customization-icon.component.html',
    styleUrls: ['./customization-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomizationIconComponent implements OnInit {
  open = false;
  ref: MatDialogRef<any>;

  constructor(public customizationService: CustomizationService) {
  }

  @HostListener(':click') openCustomization() {
    if (this.ref) {
      this.ref.close();
      this.ref = null;
    } else {
      this.ref = this.customizationService.openEditor();
      this.ref.afterClosed().pipe(first()).subscribe(() => this.ref = null);
    }
  }

  ngOnInit(): void {
  }

}
